export default "__VITE_ASSET__fslNUkB3__"